module.exports = "<ContentLoader :height=\" loaderType === 'text' ? 20: 250\" :primaryColor=\"dtPalette['grey-3']\"  >\n    <rect v-if=\"loaderType === 'text'\" x=\"0\" y=\"7\" rx=\"5\" ry=\"5\" width=\"300\" height=\"7\" />\n    <rect v-if=\"loaderType === 'checkbox'\" x=\"0\" y=\"100\" rx=\"30\" ry=\"30\" width=\"200\" height=\"80\" />\n</ContentLoader>";


//////////////////
// WEBPACK FOOTER
// ./src/containers/profile/loaders/profile-notification-type-loader/template.html
// module id = 50Hg
// module chunks = 0